// Common redirect tracking initialization
import { trackRedirectIfPresent } from '../utils/redirectTracking.js';
// Scroll-spy for the guide TOC sidebar (no-op on pages without it).
import './toc-scrollspy.js';

// Track redirects on page load
trackRedirectIfPresent();
